module.exports = __webpack_public_path__ + "static/media/button-arrow.afa771c8.svg";